import { Pages } from 'core/pages';

// Recommended resource creation order for the cricket editor.
// Person is intentionally excluded as it's not part of the setup flow.
export const GuideSteps = [
  {
    key: 'region',
    stepNumber: 1,
    name: 'Region',
    shortDescription: 'Define the geographic regions (countries, states) for your cricket ecosystem.',
    fullDescription:
      'Regions represent geographic areas like countries or states. Start here because teams, associations, and stadiums all reference a region. Create at least one region before proceeding.',
    createPage: Pages.sports.region.create,
    listPage: Pages.sports.region,
  },
  {
    key: 'team',
    stepNumber: 2,
    name: 'Team',
    shortDescription: 'Create teams that will compete in tournaments and matches.',
    fullDescription:
      'Teams are the core competing entities. Each team belongs to a region and can be assigned to tournaments. Create at least two teams so you can set up matches later.',
    createPage: Pages.sports.team.create,
    listPage: Pages.sports.team,
  },
  {
    key: 'players',
    stepNumber: 3,
    name: 'Players',
    shortDescription: 'Add players who will be part of your teams.',
    fullDescription:
      'Players are individual cricketers. They can be assigned to teams and squads within tournaments. Adding player data early ensures smooth squad selection during match setup.',
    createPage: Pages.sports.cricket.players.create,
    listPage: Pages.sports.cricket.players,
  },
  {
    key: 'stadium',
    stepNumber: 4,
    name: 'Stadium',
    shortDescription: 'Register stadiums and venues where matches will be played.',
    fullDescription:
      'Stadiums represent match venues. They are linked to a region and referenced when creating matches. Set up your venues before scheduling matches.',
    createPage: Pages.sports.stadium.create,
    listPage: Pages.sports.stadium,
  },
  {
    key: 'association',
    stepNumber: 5,
    name: 'Association',
    shortDescription: 'Set up the governing cricket association or board.',
    fullDescription:
      'Associations are the organizational bodies (e.g., BCCI, ICC) that govern competitions. An association is the parent entity for competitions and tournaments.',
    createPage: Pages.sports.association.create,
    listPage: Pages.sports.association,
  },
  {
    key: 'competition',
    stepNumber: 6,
    name: 'Competition',
    shortDescription: 'Create a competition series under an association.',
    fullDescription:
      'A competition is a recurring series (e.g., IPL, World Cup) owned by an association. Competitions contain one or more tournament editions (seasons).',
    createPage: Pages.sports.cricket.competition.create,
    listPage: Pages.sports.cricket.competition,
  },
  {
    key: 'tournament',
    stepNumber: 7,
    name: 'Tournament',
    shortDescription: 'Create a tournament edition (season) within a competition.',
    fullDescription:
      'A tournament is a specific edition or season of a competition (e.g., IPL 2025). It holds teams, rounds, and matches. Configure tournament teams and rounds after creation.',
    createPage: Pages.sports.cricket.tournament.create,
    listPage: Pages.sports.cricket.tournament,
  },
  {
    key: 'match',
    stepNumber: 8,
    name: 'Match',
    shortDescription: 'Schedule and manage individual matches within a tournament.',
    fullDescription:
      'Matches are the final entity in the chain. Each match belongs to a tournament, features two teams, is played at a stadium, and can be scored ball-by-ball or scorecard-only.',
    createPage: Pages.sports.cricket.match.create,
    listPage: Pages.sports.cricket.match,
  },
];
